import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { addLusaHeaderParam, parseUrlParams } from '../../utils/parseUrlParams';
import Header from '../../components/Header';
import ApplicationId from '../../components/ApplicationId';
import { ricWorkflowName } from '../../utils/appConstants';

const LuwaManualVerification = (props) => {
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
  const ricWorkFlow = workflowType === ricWorkflowName;

  useEffect(() => {
    const { checkinData, navigate } = props;
    const params = parseUrlParams(window.location.search);

    if (get(checkinData, ['data']) === undefined) {
      navigate(addLusaHeaderParam(`/${workflowType === 'dtm-luwa' ? 'luwa' : workflowType}/?key=${params.key}`));
    }
  }, []);

  const strHeadLine = `Unable to Sign ${ricWorkFlow ? 'Contract' : 'Loan Agreement'}`;

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      {get(props.checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(props.checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      ) : null}
      <div className="content" style={{ minHeight: 'calc(100vh - 160px)' }}>
        <h1>{strHeadLine}</h1>
        <p>
          Sorry, we were unable to confirm your identity.
          <br />
          Call (800) 994-6177 Ext 3 to continue signing the
          {' '}
          {ricWorkFlow ? 'contract' : 'loan agreement'}
          .
        </p>
      </div>
    </div>
  );
};

LuwaManualVerification.propTypes = {
  checkinData: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(LuwaManualVerification);
